import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BoxCounterUpdatedEvent } from 'src/app/models/events/box-counter-updated-event';

@Injectable({
    providedIn: 'root',
})
export class BoxCounterEventsService {
    /**
     * Emis lorsque le compteur d'une bannette est mis à jour.
     */
    public counterUpdated = new Subject<BoxCounterUpdatedEvent>();
}
